<template>
    <v-tooltip :disabled="!item.errorMessage || item.errorMessage == ''" top>
        <template v-slot:activator="{ on }">
            <v-text-field v-model="displayValue"
                          v-bind:ref="el(item, 'quantityElement')"
                          single-line
                          dense
                          hide-details
                          min="0"
                          :rules="rules"
                          :disabled="disabled"
                          :error-messages="errorMessages"
                          @blur="isInputActive = false; update(item, previousQuantity)"
                          @focus="isInputActive = true; previousQuantity = displayValue; select"
                          :tabindex="item.sequence + 1"
                          v-on="on"
                          v-on:keyup.enter="nextItem(item)"
                          v-on:keyup.up="previousItem(item)"
                          v-on:keyup.down="nextItem(item)"></v-text-field>
        </template>
        <span>{{item.errorMessage}}</span>
    </v-tooltip>
</template>

<script>
    export default {
        props: ["value", "rules", "errorMessages", "disabled", "update", "select", "el", "item", "onMoveNext", "onMovePrevious"],
        data: () => {
            return {
                isInputActive: false,
                previousQuantity: 0
            }
        },
        computed: {
            displayValue: {
                get: function () {
                    //This was throwing an error it certain cases
                    try {
                        if (this.isInputActive) {
                            return this.value.toString();
                        } else {
                            return isNaN(this.value) || this.value == 0 ? "0 " : this.value.toFixed().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
                        }
                    } catch {
                        return this.value.toString();
                    }
                },
                set: function (modifiedValue) {
                    let newValue = parseInt(modifiedValue.replace(/[^\d]/g, ""))
                    if (isNaN(newValue)) {
                        newValue = 0
                    }
                    this.$emit('input', newValue)
                }
            }
        },
        methods: {
            nextItem(item) {
                this.onMoveNext(item, 'quantityElement');
            },
            previousItem(item) {
                this.onMovePrevious(item, 'quantityElement');
            },
            focus(index) {
                if (this.$refs[index]) {
                    this.$refs[index].focus();
                }
            },
            blur(index) {
                if (this.$refs[index]) {
                    this.$refs[index].blur();
                }
            }
        }

    }
</script>